<div class="developer-container">
  <div class="description">Enable and Disable feature flags</div>
  <div class="page">
    <div class="container">
      <awc-card [elevation]="elevation" [borderRadius]="borderRadius" [awcSizing]="sizing">
        <div class="card-content">
          <div class="card-title">
            <span>Features</span>
            <span class="desc">Full features within the application, end to end workflows and similar.</span>
          </div>

          <div *ngFor="let feature of features" class="row">
            <awc-switch
              [label]="feature.replaceAll('-', ' ').replaceAll('feature', '') | titlecase"
              [cyData]="feature"
              [checked]="featureFlagsService.isFlagged(feature)"
              [disabled]="!featureFlagsEnabled"
              (checkedChange)="flagToggled(feature, $event)"
            ></awc-switch>
          </div>
        </div>
      </awc-card>

      <awc-card [elevation]="elevation" [borderRadius]="borderRadius" [awcSizing]="sizing">
        <div class="card-content">
          <div class="card-title">
            <span>Interactions</span>
            <span class="desc">Individual interaction points within the application</span>
          </div>

          <div *ngFor="let subview of subviews" class="row">
            <awc-switch
              [label]="subview.replaceAll('-', ' ').replaceAll('interaction', '') | titlecase"
              [checked]="featureFlagsService.isFlagged(subview)"
              [disabled]="!featureFlagsEnabled"
              (checkedChange)="flagToggled(subview, $event)"
            ></awc-switch>
          </div>
        </div>
      </awc-card>

      <awc-card [elevation]="elevation" [borderRadius]="borderRadius" [awcSizing]="sizing">
        <div class="card-content">
          <div class="card-title">
            <span>Views</span>
            <span class="desc"
            >UI elements that consist whole views, partial views or a collection of multiple interactions</span
            >
          </div>

          <div *ngFor="let view of views" class="row">
            <awc-switch
              [label]="view.replaceAll('-', ' ').replaceAll('view', '') | titlecase"
              [checked]="featureFlagsService.isFlagged(view)"
              [disabled]="!featureFlagsEnabled"
              (checkedChange)="flagToggled(view, $event)"
            ></awc-switch>
          </div>
        </div>
      </awc-card>
    </div>
  </div>
  <div>
    <awc-button
      [text]="'Reset to Default'"
      (buttonClicked)="onResetToDefault()"
    ></awc-button>
  </div>
</div>
